export default function removeLeadingLang (string) {
  return string.startsWith('en/') ? string.substr(3) : string
}



// WEBPACK FOOTER //
// ./client/util/removeLeadingLang.js